function postEvent(event, url, json) {
  console.log("POST EVENT: " + event);
  post(url, json, true);
}

function postEventUnasync(event, url, json) {
    console.log("POST EVENT: " + event);
  post(url, json, false);
}

function postCustomer(url, json) {
  console.log("POST CUSTOMER");
  post(url, json, true);
}

function post(url, json, async) {
  var isString = json instanceof String;
  if (!isString) {
	json = JSON.stringify(json);
  }
  
  console.log(" Json Body " + json);
  console.log("url " + url)
  $.ajax({url: url,
          type: "POST",
          "async": async,
          contentType: "application/json",
          data:json,
          success: function(result){
            console.log("Post Success");
          }, 
          error: function (result, status, err) {
            console.log("error", JSON.stringify(result));
          }
  });
}

// Manage cookie --------------------------------------------

var getCookies 	= function(){
  var pairs 	= document.cookie.split(";");
  var cookies 	= {};
  for (var i=0; i<pairs.length; i++){
    var pair 	= pairs[i].split("=");
    cookies[pair[0]] = unescape(pair[1]);
  }
  return cookies;
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function setCookie(cname, cvalue) {
    document.cookie = cname + "=" + cvalue;
}


